import { Iapi_version } from "../../types";

export const API_VERSION = Iapi_version;
